import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=58a1772c&"
import script from "./Term.vue?vue&type=script&lang=ts&"
export * from "./Term.vue?vue&type=script&lang=ts&"
import style0 from "./Term.vue?vue&type=style&index=0&id=58a1772c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports